import React from 'react';
import { FormattedMessage } from 'react-intl';

type Props = {
  onClick?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
};

export class Other extends React.Component<Props> {
  static defaultProps = {
    // eslint-disable-next-line no-console
    onClick: () => console.warn('default: Other.onClick'),
  };

  render() {
    return (
      <p className="banner-customers__message">
        <FormattedMessage id="home-expired/components/Other.tsx/1" />{' '}
        <a
          className="banner-customers__message__link"
          onClick={this.props.onClick}
        >
          <FormattedMessage id="home-expired/components/Other.tsx/2" />
        </a>
      </p>
    );
  }
}
